import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import { useDeleteMutation } from '../../../hooks/useAuthenticatedMutation';
import { Alert } from '@mui/material';
import { useQueryClient } from '@tanstack/react-query';

const DeleteTagDialog = ({ onClose, tag }) => {
    const queryClient = useQueryClient();
    const deleteMutation = useDeleteMutation(`tags/${tag.id}`, 'tags');

    const handleDelete = e => {
        e.preventDefault();
        deleteMutation.mutate({
            onSuccess: async () => {
                await Promise.all([
                    queryClient.invalidateQueries({ queryKey: ['groups'] }),
                    queryClient.invalidateQueries({ queryKey: ['segments'] })
                ]);
                onClose();
            }
        });
    };

    return (
        <Dialog onClose={onClose} open={true}>
            <form onSubmit={handleDelete}>
                <DialogTitle>Delete Tag: {tag.name}</DialogTitle>
                <DialogContent>
                    <Alert severity="info">
                        If you have this tag assigned to group(s) and/or segment(s), by deleting the tag, they will be automatically unassigned.
                    </Alert>
                    <DialogContentText sx={{ mt: 1 }}>
                        Please confirm this action.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button type="submit" loading={deleteMutation.isPending}>Confirm delete</Button>
                    <Button variant="outlined" onClick={onClose}>Cancel</Button>
                </DialogActions>
            </form>
        </Dialog>
    );
};

export default DeleteTagDialog;